import React from "react";

function ImageModel(props) {
  // eslint-disable-next-line jsx-a11y/img-redundant-alt
  return <img src={props.img2} className="img-fluid" alt="image" />;
}

export default ImageModel;
